import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class RulesService {

  public rulesUpdated: EventEmitter<boolean>;

  /**
   * Initialize an event emitter to emit rules changes
   */
  constructor() {
    this.rulesUpdated = new EventEmitter();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/rules.service.ts